import React from 'react';
import { useTranslation } from 'react-i18next';
import { RequestedTimeType } from '../../../../models/journey';
import  dayjs from 'dayjs';
import './TripTimes.scss';

export interface TripTimesProps {
  earliestPickUpDateTime: string,
  latestPickUpDateTime: string,
  latestDropOffDateTime: string,
}

const TripTimes = ({
  earliestPickUpDateTime,
  latestPickUpDateTime,
  latestDropOffDateTime,
}: TripTimesProps) => {
  const { t } = useTranslation();

  const formatTime = (date: string) => {
    return dayjs(date).format(t('trips.times.format'));
  };

  return (
    <div className="TripTimes">
      <div>
        <h4 className="TripTimesTitle">{t('trips.times.pickup')}</h4>
        <span
          className="TripTimesValue"
          dangerouslySetInnerHTML={{ __html: t('trips.times.pickupTime', { from: formatTime(earliestPickUpDateTime), to: formatTime(latestPickUpDateTime) }) }}
        />
      </div>
      <div>
        <h4 className="TripTimesTitle">{t('trips.times.type.Arrival')}</h4>
        <span className="TripTimesValue">{formatTime(latestDropOffDateTime)}</span>
      </div>
    </div>
  );
};

export default TripTimes;